import { render, staticRenderFns } from "./databaseManage.vue?vue&type=template&id=7065bad0&scoped=true"
import script from "./databaseManage.vue?vue&type=script&lang=js"
export * from "./databaseManage.vue?vue&type=script&lang=js"
import style0 from "./databaseManage.vue?vue&type=style&index=0&id=7065bad0&prod&scoped=true&lang=css"
import style1 from "./databaseManage.vue?vue&type=style&index=1&id=7065bad0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7065bad0",
  null
  
)

export default component.exports